module.exports = __webpack_public_path__ + "fonts/80c5955acfe44cbe3a353a6d3487198c.txt";